// extracted by mini-css-extract-plugin
export var addButton = "_4m-d";
export var bullets = "_4m-e";
export var compact = "_4m-2";
export var container = "_4m-j";
export var extendedWarrantyModal = "_4m-f";
export var learn = "_4m-l";
export var learnMore = "_4m-g";
export var offeringOption = "_4m-3";
export var offeringPrice = "_4m-8";
export var offeringSubtitle = "_4m-7";
export var offeringTitle = "_4m-6";
export var offeringsContainer = "_4m-0";
export var pdpTilesBackground = "_4m-n";
export var plan = "_4m-m";
export var regular = "_4m-1";
export var remove = "_4m-k";
export var seeDetailsIcon = "_4m-i";
export var seeDetailsLink = "_4m-h";
export var selectedOption = "_4m-4";
export var shieldIcon = "_4m-b";
export var shieldIconCompact = "_4m-c";
export var subtitle = "_4m-a";
export var title = "_4m-9";
export var unselectedOption = "_4m-5";